import React, { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Trash2, Building2, School } from "lucide-react";
import { toast } from "sonner";
import { apiError } from "@/lib/errors";
import { useOrgs } from "@/context/OrgsContext";
import NewUserForm from "@/components/admin/NewUserForm";

function OrgList({ title, icon: Icon, items, sub, onDelete, testid }) {
  const [q, setQ] = useState("");
  const shown = items.filter(i => i.name.toLowerCase().includes(q.toLowerCase()));
  return (
    <div className="border border-slate-300 bg-white" data-testid={testid}>
      <div className="p-4 border-b flex items-center gap-2">
        <Icon className="w-4 h-4 text-[#E11D48]"/>
        <h3 className="font-heading text-xl mr-auto">{title} <span className="text-slate-400 text-sm">({items.length})</span></h3>
        <Input placeholder="Filter…" value={q} onChange={e => setQ(e.target.value)} className="rounded-sm h-8 w-36" data-testid={`${testid}-filter`}/>
      </div>
      <ul className="divide-y max-h-[420px] overflow-auto">
        {shown.length === 0 && <li className="p-4 text-sm text-slate-400 italic">None.</li>}
        {shown.map(i => (
          <li key={i.id} className="px-4 py-2 flex items-center justify-between gap-2" data-testid={`${testid}-item-${i.id}`}>
            <div className="min-w-0"><div className="text-sm truncate">{i.name}</div>{sub && <div className="text-[11px] text-slate-500">{sub(i)}</div>}</div>
            <Button variant="ghost" size="sm" className="h-7 w-7 p-0 text-red-600" onClick={() => onDelete(i)} data-testid={`${testid}-delete-${i.id}`}>
              <Trash2 className="w-3.5 h-3.5"/>
            </Button>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default function ClientOnboardingPanel({ sports, reloadUsers }) {
  const { orgs, reloadOrgs } = useOrgs();
  const assocName = id => orgs.associations.find(a => a.id === id)?.name || "—";
  const del = async (path, item) => {
    if (!window.confirm(`Delete "${item.name}"?`)) return;
    try { await api.delete(`${path}/${item.id}`); toast.success("Deleted"); reloadOrgs(); }
    catch (e) { toast.error(apiError(e)); }
  };

  return (
    <div className="grid lg:grid-cols-[420px_1fr] gap-6" data-testid="client-onboarding-panel">
      <NewUserForm roles={["association_admin", "school_admin", "coach", "viewer", "super_admin"]} sports={sports}
        onCreated={() => { reloadOrgs(); reloadUsers(); }} title="ONBOARD A CLIENT" testid="onboarding-form"/>
      <div className="grid md:grid-cols-2 gap-4 h-fit">
        <OrgList title="ASSOCIATIONS" icon={Building2} items={orgs.associations} testid="org-associations"
          sub={a => `${orgs.schools.filter(s => s.association_id === a.id).length} schools${a.id === orgs.default_association_id ? " · default" : ""}`}
          onDelete={a => del("/associations", a)}/>
        <OrgList title="SCHOOLS" icon={School} items={orgs.schools} testid="org-schools"
          sub={s => assocName(s.association_id)} onDelete={s => del("/schools", s)}/>
      </div>
    </div>
  );
}
